import Icon from '../components/Icon.vue'

Icon.register({
  'file-audio': {
    width: 384,
    height: 512,
    paths: [
      {
        d: 'M224 136c0 13.2 10.8 24 24 24h136v328c0 13.3-10.7 24-24 24h-336c-13.3 0-24-10.7-24-24v-464c0-13.3 10.7-24 24-24h200v136zM160 404v-136c0-10.7-12.9-16.1-20.5-8.5l-35.5 36.5h-28c-6.6 0-12 5.4-12 12v56c0 6.6 5.4 12 12 12h28l35.5 36.5c7.6 7.5 20.5 2.2 20.5-8.5zM193.2 356.4c-22.5 23.1 12.6 55.8 34.4 33.5 27.2-28 27.2-72.5 0-100.4-22.2-22.7-56.5 10.7-34.4 33.5 9.1 9.3 9.1 24.1 0 33.4zM279.2 239.3c-22.1-22.8-56.5 10.7-34.4 33.5 36.3 37.3 36.2 96.6 0 133.8-22.6 23.2 12.6 55.9 34.4 33.5 54.4-56 54.4-144.9 0-200.8zM384 121.9v6.1h-128v-128h6.1c6.4 0 12.5 2.5 17 7l97.9 98c4.5 4.5 7 10.6 7 16.9z'
      }
    ]
  }
})
